// Generated by genversion.
export const version = '5.0.0-alpha.116'
